import React, { useContext, useRef, useEffect } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { BiLeftArrowCircle } from "react-icons/bi";
import { BiRightArrowCircle } from "react-icons/bi";
import { EventsContext } from '../context/EventsContext';

function Sliderss() {
    const { images, setImages, mySlider, setMySlider, toShow, setToShow } = useContext(EventsContext);
    const slidersRef777 = useRef(null);

    // Slider settings
    const settings = {
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 1,
        arrows: false,
    };

    useEffect(() => {
        if (images) {
            // console.log(images,"here images");

        }
    }, [images])
    // Effect to move to the specified slide (toShow)
    useEffect(() => {
        // console.log(toShow,"to show is here");

        if (toShow !== undefined && slidersRef777.current) {
            slidersRef777.current.slickGoTo(toShow);
        }
    }, [toShow]); // This will run every time `toShow` changes

    return (
        <>
            {images && (
                <div className={mySlider ? "slider-small-is-active" : "slider-small-is-unactive"} onClick={() => setMySlider(false)}>
                    <div className={mySlider ? "slider-small-inner-is-active" : "slider-small-inner-is-unactive"} onClick={(e) => e.stopPropagation()}>
                        <div className="slider-container777">
                            <button
                                className="slider-arrow777 left777"
                                onClick={() => slidersRef777.current.slickPrev()}
                            >
                                <BiLeftArrowCircle />
                            </button>

                            <div className="slider-wrapper555">
                                <Slider ref={slidersRef777} {...settings}>
                                    
                                    {images.map((item) => (
                                        <div key={item.id} className="slide-item">
                                            <div className="slider-d-jhu777" style={{ cursor: "pointer" }}>
                                                <div className="podcast-hjgwqjht777">
                                                    <img
                                                        className="css-nadvt4"
                                                        src={item}
                                                        alt={`Slide ${item}`}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                            </div>

                            <button
                                className="slider-arrow777 right777"
                                onClick={() => slidersRef777.current.slickNext()}
                            >
                                <BiRightArrowCircle />
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default Sliderss;
